import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "登录", -1);

var _hoisted_2 = /*#__PURE__*/_createTextVNode("登录");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("重置");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_el_form, {
    ref: "loginRef",
    model: $setup.loginForm,
    rules: $setup.rules,
    "label-width": "120px"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_form_item, {
        label: "邮箱",
        prop: "account"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            placeholder: "请输入邮箱...",
            modelValue: $setup.loginForm.account,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $setup.loginForm.account = $event;
            }),
            autocomplete: "off"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "密码",
        prop: "password"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            placeholder: "请输入密码...",
            modelValue: $setup.loginForm.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $setup.loginForm.password = $event;
            }),
            type: "password",
            autocomplete: "off"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return $setup.submitForm();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: $setup.resetForm
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model", "rules"])], 64);
}